<h2 class="flex flex-row items-center gap-3" mat-dialog-title>
  <mat-icon svgIcon="add_task"></mat-icon>
  {{ "Today's Activity" | transloco }}
</h2>

<div class="flex flex-col w-full mt-6 h-[88%]">
  <div class="flex overflow-y-auto max-h-100">
    <table [dataSource]="phasesActivities" class="w-full mt-4" mat-table>
      <!-- Phase Desc Column -->
      <ng-container matColumnDef="phase_name">
        <th *matHeaderCellDef mat-header-cell>
          {{ 'Phase Name' | transloco }}
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <div class="flex items-baseline">
            {{ element.phase_name | titlecase }}
          </div>
        </td>
      </ng-container>

      <!-- Phase Desc Column -->
      <ng-container matColumnDef="name">
        <th *matHeaderCellDef mat-header-cell>
          {{ 'Activity Name' | transloco }}
        </th>
        <td *matCellDef="let element; let i = index" mat-cell>
          <div class="flex items-baseline">
            {{ element.name | titlecase }}
          </div>
        </td>
      </ng-container>

      <!-- Progress Column -->
      <ng-container matColumnDef="completion_percentage">
        <th *matHeaderCellDef mat-header-cell style="text-align-last: center">
          {{ 'Progress' | transloco }}
        </th>
        <td *matCellDef="let element" mat-cell>
          <div *ngIf="!isDashboard" class="flex flex-col w-full items-center">
            <span class="text-smaller">{{ element.completion_percentage || 0 }}%</span>
            <mat-slider
              #sliderRef
              (change)="onCompletionPercentageChange(element)"
              (mouseup)="onSliderMouseUp(sliderRef)"
              [(ngModel)]="element.completion_percentage"
              [dir]="isArabic()"
              [valueText]="element.completion_percentage"
              class="text-primary"
              max="100"
              min="0"
              thumbLabel
              tickInterval="1"
            ></mat-slider>
          </div>
          <div *ngIf="isDashboard">
            <span>{{ element.completion_percentage || 0 }}%</span>
          </div>
        </td>
      </ng-container>

      <tr *matHeaderRowDef="displayedActivitiesColumns" mat-header-row></tr>
      <tr
        *matRowDef="let row; columns: displayedActivitiesColumns"
        [ngClass]="{
          'opacity-20': row.progress === 0 || row.progress === 100
        }"
        class="hover:bg-accent-900 hover:opacity-100"
        mat-row
      ></tr>
    </table>
  </div>

  <div class="flex">
    <mat-paginator
      (page)="onPaginatorPageChange($event)"
      [length]="_projectPlanning.totalActivities"
      [pageSizeOptions]="[5, 10, 20, 50]"
      [pageSize]="5"
      aria-label="Select page of progresses"
      class="flex flex-row justify-end w-full"
      showFirstLastButtons
    >
    </mat-paginator>
  </div>
</div>

<!-- Display message when there are no activities -->
<div
  *ngIf="!phasesActivities?.length"
  class="flex flex-row w-full justify-center text-secondary items-center"
>
  <div>
    <mat-icon class="mt-1" svgIcon="add_task"></mat-icon>
  </div>
  <div>
    {{ 'No Activities for today' | transloco }}
  </div>
</div>
